import { parseHTML } from "utils/htmlParser";

export function mapSectionProps(section) {
	const unifiedMedia = section.medias || section.media?.[16600] || section.media || [];
	return {
		fluid: section.fluid || 0,
		alignment: section.alignment,
		alignment_title: section.alignment_title,
		alignment_content: section.alignment_content,
		text_alignment_title: section.text_alignment_title,

		vertical_alignment_title: section.vertical_alignment_title,
		vertical_alignment_content: section.vertical_alignment_content,

		order: section.order,
		data: section.data || section.module_details,
		url: section.url,

		form: section.form,

		containerLayout: section.containerLayout,
		isInContainerGrid: section.isInContainerGrid,
		isSubsection: section.isSubsection,

		col_width: section.col_width,
		col_width_title: section.col_width_title,
		col_width_content: section.col_width_content,

		text_color_title: section.text_color_title,
		bg_color: section.bg_color,
		bg_blur: section.bg_blur,

		max_count: section.max_count,
		items_per_line: section.items_per_line || 3,
		tablet_items_per_line: section.tablet_items_per_line || 2,
		mobile_items_per_line: section.mobile_items_per_line || 1,

		contrast_schema: section.contrast_schema,

		title: section.title,
		short_desc: section.short_desc,
		desc: parseHTML(section.desc),

		list: section.list,

		cta_text: section.cta_text,
		cta_link: section.cta_link,
        
		media: unifiedMedia,
		bg_image: section.media?.[16610]?.[0],
		module_details: section.module_details,
		view: section.global_view,
		view_id: section.view_id,

		back_link: section.back_link,
		back_link_text: section.back_link_text,

		type_id: section.type_id,
		subsections: section.subsections ?? [],
		
		// Spacing properties
		padding_y: section.padding_y !== undefined ? section.padding_y : 7,
		padding_x: section.padding_x !== undefined ? section.padding_x : 3,
		margin_y: section.margin_y !== undefined ? section.margin_y : 0,
		margin_x: section.margin_x !== undefined ? section.margin_x : 0,

		is_absolute: section.is_absolute || false,
	};
}

